import React from 'react';
import mapboxgl from 'mapbox-gl';
import Map from 'react-map-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import './Map.scss';
import { INITIAL_VIEW_STATE } from './MapHelper';

type SimpleMapProps = {
  accessToken: string;
  styleUrl?: string;
  className?: string;  
};

const SimpleMap: React.FC<SimpleMapProps> = ({
  accessToken,
  styleUrl = 'mapbox://styles/mapbox/streets-v12',
  className = 'map-container',
}) => {
  return (
    <div className={className}>
      <Map
        mapLib={mapboxgl as any}
        mapboxAccessToken={accessToken}
        mapStyle={styleUrl}
        initialViewState={INITIAL_VIEW_STATE}
        style={{ position: 'fixed', width: '100vw', height: '100vh' }}
      />
    </div>
  );
};

export default SimpleMap;
